export enum AppEventType {
  CURRENT_ROUTE = 'CURRENT_ROUTE',
}

export class AppEvent<T> {
  type: AppEventType;
  payload: T;
}
